"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _buttons = require("@vds-core/buttons");
var propTypes = {
  /**
   * If true, will render a Primary button (default).
   */
  primary: _propTypes["default"].bool,
  /**
   * If true, will render a Secondary Button.
   */
  secondary: _propTypes["default"].bool,
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool
};
var defaultProps = {
  inverted: false,
  primary: false,
  secondary: false
};
var Button = function Button(props) {
  var width = props.width,
    size = props.size,
    inverted = props.inverted,
    secondary = props.secondary;
  function _calculateButtonHeight(size) {
    var height;
    if (size === "small") {
      height = (0, _javascriptStyleHelpers.calculateRem)(28);
    } else {
      height = (0, _javascriptStyleHelpers.calculateRem)(44);
    }
    return height;
  }
  function _calculateBorderRadius(size) {
    return (0, _javascriptStyleHelpers.calculateRem)(100);
  }
  function _calculateSideMargin(size, width) {
    var sideMargin, verticalMargin;
    if (size === "small") {
      sideMargin = 16;
      verticalMargin = 5;
    } else {
      sideMargin = width === "auto" ? 44 : 22;
      verticalMargin = 11;
    }
    return (0, _javascriptStyleHelpers.calculateRem)(verticalMargin, sideMargin);
  }
  function _calculateMinWidth(size) {
    return undefined;
  }
  return /*#__PURE__*/_react["default"].createElement(_buttons.Button, (0, _extends2["default"])({}, props, {
    use: secondary ? "secondary" : "primary",
    surface: inverted ? "dark" : "light",
    width: size === "small" ? "auto" : width,
    calculateButtonHeight: _calculateButtonHeight,
    calculateSideMargin: _calculateSideMargin,
    calculateBorderRadius: _calculateBorderRadius,
    calculateMinWidth: _calculateMinWidth,
    calculateFontWeight: 700
  }));
};
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
Button.displayName = "Button";
var _default = exports["default"] = Button;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/buttons/dist/cjs/components/Button.js
// module id = 559
// module chunks = 0